import { ROLES } from '@/lib/constants/app.constants';

/**
 * Returns true when the user may access supplier-portal protected routes (supplier or system admin).
 * Comparisons are case-insensitive so they survive provider / DB casing differences.
 */
export function hasSupplierPortalAccess(roles: string[] | undefined): boolean {
  if (roles == null || roles.length === 0) {
    return false;
  }
  const normalized = roles.map((r) => r.toLowerCase());
  return (
    normalized.includes(ROLES.BOOKING_REQUESTER.toLowerCase()) ||
    normalized.includes(ROLES.SYSTEM_ADMIN.toLowerCase())
  );
}
